import { useEffect, useState } from "react"
import { defaultCardSelection, GroupHeader, groupSelector, handleMultiple, mainHeader, multipleAnswerForm, selectHeader, singleAnswerForm } from "./functions"

const structureOpt = [
  "Concreto Armado",
  "Metálica",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const preFinishOpt = [
  "Contrapiso comum",
  "Contrapiso acústico",
  "Contrapiso autonivelante",
  "Regularização (exceto impermeabilização)",
  "Proteção mecânica",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const finishOpt = [
  "Pedra",
  "Porcelanato",
  "Peça Cerâmica",
  "Pastilha",
  "Cimentado",
  "Polimento",
  "Madeira",
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Concreto Estampado",
  "Sem Acabamento",
  "Outro",
  "Seguir Descrição do Projeto",
  "Definir Posteriormente"
]

const roofPrefinishOpt = [
  "Estucamento",
  "Regularização (exceto impermeabilização)",
  "Chapisco",
  "Emboço + Reboco",
  "Reboco em Massa Única",
  "Gesso Corrido",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const roofFinishOpt = [
  "Pintura",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "Placa Cimentícia",
  "Madeira",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const handrailOpt = [
  "Madeira",
  "Metal",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const StairsQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { stairs } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), preFinish: [], finish: "", roofPrefinish: [], mirrorFinish: '', mirrorPreFinish: [] }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`stairs-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(stairs).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(stairs))
    }
  }

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => stairs.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => formData.roomDefinitions.stairs.includes(i))
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = formData.rooms.filter(i => !privAreas.includes(i)).filter(i => formData.roomDefinitions.stairs.includes(i))
      setCurrentGroup(common)
    }
  }

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleMultipleChanges = (idx, field, type) => {
    handleMultiple(finished, groups, idx, field, type, { type, preFinish: "", roofPrefinish: [], thickness: "" }, setGroups);
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Escadas", groups, resetAll, toggle, setToggle)}
    {toggle && <>
      {groups.length > 0 && <>
        {groups.map((i, idx) => {
          return <div id={`stairs-${idx}`} key={idx}>
            <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />

            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {singleAnswerForm("Qual estrutura será utilizada na escada dos ambientes desse grupo?", structureOpt, idx, "structure", formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", groups[idx], handleChanges, finished)}

              {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados no piso da escada dos ambientes desse grupo?", preFinishOpt, idx, "preFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", handleChanges, finished)}

              {i.preFinish.some(j => preFinishOpt.slice(0, 5).includes(j.type)) && (

                <div className="question-container">
                  <p className="margin-tier-1">Espessuras (cm):</p>
                  {i.preFinish.map((j, idx2) => {
                    if (!preFinishOpt.slice(0, 5).includes(j.type)) return;
                    return <div key={idx2} className="margin-tier-2 margin-bottom-8">
                      <label>{j.type}</label>
                      <input type="number" value={j.thickness} onChange={(e) => {
                        const newGroups = [...groups];
                        newGroups[idx].preFinish[idx2].thickness = e.target.value;
                        setGroups(newGroups);
                      }} />
                    </div>
                  })}
                </div>
              )}

              {singleAnswerForm("Qual opção de acabamento será utilizado no piso da escada dos ambientes desse grupo?", finishOpt, idx, "finish", formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", groups[idx], handleChanges, finished)}

              {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados no teto da escada dos ambientes desse grupo?", roofPrefinishOpt, idx, "roofPrefinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", handleChanges, finished)}




              {singleAnswerForm("Qual opção de acabamento será utilizado nos espelhos da escada dos ambientes desse grupo?", [...finishOpt, 'Mesmo do piso'], idx, "mirrorFinish", formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", groups[idx], handleChanges, finished)}

              {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados nos espelhos da escada dos ambientes desse grupo?", [...roofPrefinishOpt, 'Mesmo do piso'], idx, "mirrorPreFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", handleChanges, finished)}





              {singleAnswerForm("Qual opção de acabamento será utilizado no teto da escada dos ambientes desse grupo?", roofFinishOpt, idx, "roofFinish", formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", groups[idx], handleChanges, finished)}

              {singleAnswerForm("Qual material dos corrimões das escadas?", handrailOpt, idx, "handrail", formData.projRoomFull, "Materiais da Escada (Estrutura, piso, teto, corrimão)", groups[idx], handleChanges, finished)}

            </div>}
          </div>
        })}
      </>}
      {checkRemaining(stairs).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}

      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, stairs)}
    </>}
  </div>
}

export default StairsQuestions;